import KeyIcon from '@/assets/icons/key.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ResetPasswordHeader } from '../components/ResetPasswordHeader';
import { ResetPasswordForm } from './ResetPasswordForm/ResetPasswordForm';

type ResetPasswordFormContentProps = {
  onPasswordRecoverySent: ({ email }: { email: string }) => void;
};

export const ResetPasswordFormContent: FC<ResetPasswordFormContentProps> = ({ onPasswordRecoverySent }) => {
  const { t } = useTranslation();

  return (
    <>
      <ResetPasswordHeader icon={<KeyIcon />} title='ALL:forgotYourPassword' subtitle={t('ALL:downWorryRequestNewOne')} />
      <ResetPasswordForm onPasswordRecoverySent={onPasswordRecoverySent} />
    </>
  );
};
